import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query getBusinessSettings($businessId: ID!) {
    businessSettings(businessId: $businessId) {
      industry
      showUntil {
        seconds
      }
      companySize {
        upper {
          value
        }
        lower {
          value
        }
      }
    }
  }
`

export const businessSettingsKey = getQueryNames(query)[0]

export default query
